var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.activeGroup === 'yourcolors' ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpen,
      expression: "isOpen"
    }],
    ref: "wrapper",
    staticClass: "pick-your-own-color-picker pick-your-own-color-picker--open"
  }, [_c('div', {
    staticClass: "pick-your-own-color-picker__visible-area",
    on: {
      "touchmove": function touchmove($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onDragHandlebar.apply(null, arguments);
      }
    }
  }, [_c('button', {
    staticClass: "pick-your-own-color-picker__close-button",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onClose.apply(null, arguments);
      }
    }
  }, [_c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-close.svg")
    }
  })], 1), _vm.isMobile ? _c('div', {
    staticClass: "pick-your-own-color-picker__drag-handler"
  }, [_vm._v("\n       \n    ")]) : _vm._e(), _vm._m(0)]), _c('div', {
    staticClass: "pick-your-own-color-picker__collapsible-area"
  }, [_c('div', {
    staticClass: "pick-your-own-color-picker__color-preview",
    style: {
      backgroundColor: _vm.colorValue
    }
  }), _c('div', {
    staticClass: "pick-your-own-color-picker__color-picker"
  }, [_c('div', {
    ref: "colorContainer",
    staticClass: "pick-your-own-color-picker__color-picker-container",
    attrs: {
      "id": "pick-your-own-color-picker__color-picker-container-".concat(_vm.uuid)
    }
  }, [_c('input', {
    ref: "colorInput",
    staticClass: "jscolor pick-your-own-color-picker__color-picker-input",
    attrs: {
      "data-jscolor": "{'container': 'pick-your-own-color-picker__color-picker-container-".concat(_vm.uuid, "'}"),
      "tabindex": "-1"
    },
    domProps: {
      "value": _vm.value
    }
  })])]), _c('div', {
    staticClass: "pick-your-own-color-picker__buttons-wrapper"
  }, [_c('div', {
    staticClass: "pick-your-own-color-picker__button-wrapper"
  }, [_c('button', {
    class: ['button customs-rounded-button pick-your-own-color-picker__button pick-your-own-color-picker__add-color', {
      'customs-rounded-button--disabled': !_vm.enableAddSwatch
    }],
    attrs: {
      "disabled": !_vm.enableAddSwatch
    },
    on: {
      "click": _vm.addSwatch
    }
  }, [_c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/apparelNavigation/icon-plus.svg")
    }
  }), _vm._v("\n          Add\n        ")], 1)]), _c('div', {
    staticClass: "pick-your-own-color-picker__button-wrapper"
  }, [_c('button', {
    class: ['button customs-rounded-button pick-your-own-color-picker__button pick-your-own-color-picker__remove-color', {
      'customs-rounded-button--disabled': !_vm.enableRemoveSwatch
    }],
    attrs: {
      "disabled": !_vm.enableRemoveSwatch
    },
    on: {
      "click": _vm.setIsRemoving
    }
  }, [_c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/apparelNavigation/icon-minus.svg")
    }
  }), _vm._v("\n          Remove\n        ")], 1)])])])]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pick-your-own-color-picker__content"
  }, [_c('div', {
    staticClass: "pick-your-own-color-picker__title"
  }, [_vm._v("\n        PICK YOUR OWN COLOR\n      ")])]);
}]

export { render, staticRenderFns }